import RequestFormResourcePagingResultModel from '../../generated/types/model/resource/RequestFormResourcePagingResultModel';

export default class RequestFormResourcePagingResultViewModel extends RequestFormResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
